/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q19Inputs */

const et_faq_q19 = /** @type {(inputs: Faq_Q19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas tõsta kodulehe konversioonimäära kiirelt?`)
};

const en_faq_q19 = /** @type {(inputs: Faq_Q19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can I quickly increase my website's conversion rate?`)
};

/**
* | output |
* | --- |
* | "How can I quickly increase my website's conversion rate?" |
*
* @param {Faq_Q19Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q19 = /** @type {((inputs?: Faq_Q19Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q19Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q19(inputs)
	return en_faq_q19(inputs)
});